import { CommonModule } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core'
import { SharedModule } from '@app/shared/shared.module'
import { MenuOptions } from '@core/model/definitions/menu-options.interface'

@Component({
  selector: 'scope-ui-options-menu',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './scope-ui-options-menu.component.html',
  styleUrls: ['./scope-ui-options-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScopeUiOptionsMenuComponent implements OnChanges {
  @Input() menuOptions!: MenuOptions[]
  @Input() buttonText?: string
  @Input() toggleButton?: boolean
  @Input() separatedMenu?: boolean
  @Input() element?: any
  @Input() parentElement?: any
  @Output() onClickEvent = new EventEmitter<any>()

  hasMenuOptions: boolean

  ngOnChanges(changes: SimpleChanges) {
    if (changes.menuOptions || changes.element)
      this.hasMenuOptions = !!this.menuOptions?.filter((option) => !option.isHidden || !option.isHidden(this.element))
        .length
  }

  onClick() {
    this.onClickEvent.emit()
  }
}
